export default class Units {
  public weight!: string;
  public length!: string;

  public constructor(init?: Partial<Units>) {
    Object.assign(this, init);
  }
}
